export default __webpack_public_path__ + "static/dd-hospitality-7925f3b72edf822f6b454d32efb075fb.jpg";